import { NgModule } from '@angular/core';

import { ControlErrorFactoryService } from '@svg-frontends/error';

@NgModule({
	providers: [{ provide: ControlErrorFactoryService, useClass: ControlErrorFactoryService }],
})
export class ErrorMessageModule {}
